// // src/index.js
// import React from 'react';
// import ReactDOM from 'react-dom/client'; // Use the new ReactDOM API
// import App from './App';
// import { BrowserRouter as Router } from 'react-router-dom'; // Only here in index.js
// // src/index.js
// import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
// import "bootstrap/dist/js/bootstrap.bundle.min.js";


// // Create root and render the app
// const root = ReactDOM.createRoot(document.getElementById('root'));

// // Wrap the entire app with Router here, NOT inside App.js
// root.render(
//   <React.StrictMode>
//     <Router>
//       <App />
//     </Router>
//   </React.StrictMode>
// );


// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { HashRouter } from 'react-router-dom'; // ✅ use HashRouter instead of BrowserRouter
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Create root and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);

